
<div class="container pay-now-container">
  <div class="row row-1">
    <div class="col-sm-7 col-1">
      <h2 class="overview-header pay-now-header">Pay Now</h2>
    </div>
    <div class="col-sm-5 col-2">
      <!--<h4><a class="bp-link-red pay-bills-link float-right">Pay Multiple Bills<i class="fas fa-chevron-right view-more-arrow pay-bills-arrow fa-xs"></i></a></h4>-->
    </div>
  </div>

  <div class="card" style="padding-bottom: 1.5rem;">
    <div class="card-header bp-card-header">
      <!-- Steps form -->
      <div class="card">
        <div class="card-body mb-4">
          <!-- Stepper -->
          <div class="steps-form">
            <div class="steps-row setup-panel">
              <div class="steps-step step-1">
                <a href="#step-9" type="button" class="btn btn-indigo btn-circle">1</a>
                <p class="bp-text">Setup</p>
              </div>
              <div class="steps-step step-2">
                <a href="#step-10" type="button" class="btn btn-default btn-circle" disabled="disabled">2</a>
                <p class="bp-text">Review</p>
              </div>
              <div class="steps-step step-3">
                <a href="#step-11" type="button" class="btn btn-default btn-circle" disabled="disabled">3</a>
                <p class="bp-text">Confirmation</p>
              </div>
            </div>
          </div>

          <form role="form" action="" method="post">

            <!-- First Step -->
            <div class="row setup-content" id="step-9">
              <div class="col-md-12">
              </div>
            </div>

            <!-- Second Step -->
            <div class="row setup-content" id="step-10">
              <div class="col-md-12">
              </div>
            </div>

            <!-- Third Step -->
            <div class="row setup-content" id="step-11">
              <div class="col-md-12">
              </div>
            </div>

          </form>

        </div>
      </div>
      <!-- Steps form -->
    </div>
    <div class="card-body">
      <div class="row"></div>
      <div class="row"></div>
      <div class="row">
        <div class="col-sm-4 text-align-left bp-text bp-medium-text">
          <h4>Account</h4>
        </div>
        <div class="col-sm-4 text-align-right bp-text bp-medium-text">
          <h4>Draft Date</h4>
        </div>
        <div class="col-sm-4 text-align-right bp-text bp-medium-text">
          <h4>Total Due</h4>
        </div>
      </div>
      <div class="row border">
        <div class="col-sm-4 text-align-left">
          <p class="bp-text bp-bold-text" style="margin-top: 1.0rem; margin-bottom: 0rem;">
            {{streetAddress}}
          </p>
          <p class="bp-text">{{cityStateZip}}</p>
          <p class="bp-text">{{acctNumber}}</p>
        </div>
        <div class="col-sm-4 text-align-right">
          <p class="bp-text" style="margin-top: 2.0rem; font-size: 1.5rem;">
            09/19/2018
          </p>
        </div>
        <div class="col-sm-4 text-align-right">
          <p class="bp-text bp-bold-text bp-big-text" style="margin-top: 1.0rem;">
            $0.00
          </p>
        </div>
      </div>
      <div class="row border">
        <div class="col-sm-12 text-align-right">
          <p style="margin-top: 0.9rem;" class="bp-text">Reflects Pending Payments</p>
        </div>
      </div>
      <div class="row border">
        <div class="col-sm-12 text-align-left">
          <p class="bp-bold-text bp-text" style="margin-top: 1.0rem;font-size:1.7rem;">Your Water Bill could be $0.00 next month if you were enrolled in FlatBill<i class="fas fa-info-circle fa-xs"></i></p>
          <p class="bp-text">FlatBill offers a 12-month fixed contracted price that does not fluctuate when your water usage does. FlatBill looks at your bills for the last 12 months, the expected weather for the upcoming 12 months, and predicted changes in water use, and then creates a custom FlatBill offer for qualified customers.</p>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="enrollChkbx">
            <label style="font-weight: 300;" class="form-check-label bp-text" for="enrollChkbx">Enroll in FlatBill | <a style="font-weight:bold;">Terms and Conditions.</a></label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-align-left" style="padding-left: .2rem;">
          <h3 style="font-weight: 300;" class="bp-medium-text">Select Payment Method</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-5" style="padding-left: 0rem;">
          <select class="bp-medium-text form-control">
            <option value="">Please chooose an option...</option>
            <option value="">Debit Card (No Fee)</option>
            <option value="">E Check, Debit, Credit Card ($2.25)</option>
          </select>
        </div>
      </div>
    </div>
    <footer class="blockquote-footer water-usage-footer"></footer>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pay-now/pay-now.component.html